// seconds in a time unit
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3_600;
const SECONDS_PER_DAY = 86_400;
/**
 * Get a object with seconds/minutes/hours/days from milliseconds
 *
 * @example
 *
 * import { Time } from '@catawiki/runtime-toolkit';
 *
 * const timeFrom = 1496830169273;
 * const timeTo = 1497032420000;
 * const timeDifference = Time.getTimeDifference(timeFrom, timeTo);
 * const {seconds, minutes, hours, days} = timeDifference;
 *
 * assert.deepStrictEqual(timeDifference.length, 4);
 * assert.deepStrictEqual(seconds, 50);
 * assert.deepStrictEqual(minutes, 10);
 * assert.deepStrictEqual(hours, 8);
 * assert.deepStrictEqual(days, 2);
 *
 * @param {number} timeFrom The the start time in milliseconds
 * @param {number} timeTo The end time in milliseconds
 * @return {{seconds: number, minutes: number, hours: number, days: number}} The time difference in seconds, minutes, hours and days
 */
export const getTimeDifference = (timeFrom, timeTo) => {
    const totalSeconds = (parseInt(timeTo.toString(), 10) - parseInt(timeFrom.toString(), 10)) /
        1000;
    const seconds = Math.floor(totalSeconds % SECONDS_PER_MINUTE);
    const minutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
    const hours = Math.floor((totalSeconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR);
    const days = Math.floor(totalSeconds / SECONDS_PER_DAY);
    return { seconds, minutes, hours, days };
};
/**
 * Converts milliseconds to seconds, minutes, hours and days.
 *
 * @example
 *
 * import { Time } from '@catawiki/runtime-toolkit';
 *
 * const relativeTime = Time.convertMillisecondsToRelativeTime(1_000_000);
 * const {seconds, minutes, hours, days} = timeDifference;
 * assert.deepStrictEqual(seconds, 16);
 * assert.deepStrictEqual(minutes, 16);
 * assert.deepStrictEqual(hours, 0);
 * assert.deepStrictEqual(days, 0);
 *
 * @param {number} time The time in milliseconds
 * @return {{seconds: number, minutes: number, hours: number, days: number}} The time in seconds, minutes, hours and days
 */
export const convertMillisecondsToRelativeTime = (time) => getTimeDifference(0, time);
